var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFloatingOuter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112.358,
    height: 112.697,
    viewBox: "0 0 112.358 112.697",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "yEq5Zc",
    transform: "translate(-1654.086 -920.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2197",
    "data-name": "Group 2197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3586",
    "data-name": "Path 3586",
    d: "M1710.121,920.018c96.492,8.862,56.631,143.577-26.714,105.671-6.488-1.223-35.13,14.38-28.266,2.6,9.4-18.436,1.806-31.98-.957-50.976C1653.489,944.874,1679.753,920.329,1710.121,920.018Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3587",
    "data-name": "Path 3587",
    d: "M1709.794,1022.943c-8.592.958-17.777-5.112-26.708-7.081-22.766,6.877-14.226,4.218-11.5-12.992-5.577-10.56-9.786-21.46-7.385-34.568,7.493-41.238,56.6-50.136,80.484-24C1773.469,975.027,1749.585,1023.591,1709.794,1022.943Z",
    fill: "#4eb85f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingOuter);
export default __webpack_public_path__ + "static/media/floating_outer.3d0b7c17ce32aa0590181d0b5a60b50b.svg";
export { ForwardRef as ReactComponent };